// src/utils/mAndA.js
//
// Canonical M&A integration tags — frontend cache of the m_and_a_tags DB table.
// Source of truth at runtime is the DB; this constant is used for filter
// dropdown rendering and client-side validation. Update all three sites
// together when adding/removing tags.
//
// Three-site canonical list — keep in sync with:
//   - DB:     db/migrations/0007_business_units.sql (initial seed) +
//             db/migrations/0008_rename_business_to_ma.sql (rename + retire core).
//             m_and_a_tags table is the runtime source of truth.
//   - Server: VALID_M_AND_A_IDS in server/routes/locations.js + operations.js

export const M_AND_A_TAGS = [
  { id: "treasury", name: "Treasury" },
  { id: "prime",    name: "Prime" },
  { id: "custody",  name: "Custody" },
];

export const M_AND_A_IDS = new Set(M_AND_A_TAGS.map((t) => t.id));

export function isValidMAndATagId(value) {
  return typeof value === "string" && M_AND_A_IDS.has(value);
}

/**
 * Resolve an M&A tag id to its display name.
 * Returns "—" for null/undefined/empty (the "unassigned" rendering convention).
 * Returns the raw id wrapped in "(unknown)" if the id doesn't match the canonical
 * set — a defensive case for data drift (e.g. a tag was retired but locations still
 * reference it). The UI should never silently lose user data.
 */
export function getMAndATagName(id) {
  if (!id) return "—";
  const found = M_AND_A_TAGS.find((t) => t.id === id);
  return found ? found.name : `${id} (unknown)`;
}
